import { Link } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import { HERO_IMAGES } from "../lib/constants";
import { Target, ShieldCheck, Send, Search } from "lucide-react";

export default function Brands() {
    return (
        <PageLayout>
            <section className="relative min-h-[50vh] flex items-end pb-16 pt-32 border-b border-white/10 overflow-hidden">
                <img src={HERO_IMAGES.basketball} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
                <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-5">Brands & Sponsors</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-none tracking-tight" data-testid="brands-heading">
                        PARTNER WITH THE<br/><span className="text-[#d4af37]">NEXT GENERATION.</span>
                    </h1>
                    <p className="text-white/70 max-w-2xl mt-6 text-lg">
                        Reach engaged local and national audiences through vetted, compliant partnerships with high school and collegiate athletes.
                    </p>
                </div>
            </section>

            <section className="py-16 md:py-24">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                    {[
                        { icon: Search, t: "Search Athletes", d: "Filter by sport, audience, position, causes and more." },
                        { icon: Send, t: "Submit Proposals", d: "Send campaign briefs and budgets through our management portal." },
                        { icon: ShieldCheck, t: "Fully Managed", d: "Every touchpoint goes through Digital Beast — no unrestricted DMs to minors." },
                        { icon: Target, t: "Report & Renew", d: "Campaign reporting, deliverable tracking and renewal opportunities in one place." },
                    ].map(({icon: I, t, d}) => (
                        <div key={t} className="surface p-7" data-testid={`brand-feat-${t.toLowerCase().replace(/\s+/g,'-')}`}>
                            <I className="text-[#d4af37]" size={26} strokeWidth={1.5} />
                            <div className="font-display text-xl mt-5 text-white">{t}</div>
                            <p className="text-white/60 mt-3 text-sm leading-relaxed">{d}</p>
                        </div>
                    ))}
                </div>

                <div className="max-w-3xl mx-auto px-5 mt-20 text-center">
                    <h2 className="font-display text-4xl md:text-5xl text-white tracking-tight">
                        Ready to <span className="text-[#d4af37]">activate</span>?
                    </h2>
                    <p className="text-white/60 mt-4">Register as a sponsor to browse athletes and submit proposals.</p>
                    <div className="mt-8 flex justify-center gap-3">
                        <Link to="/register?role=sponsor" className="btn-gold" data-testid="brand-register">Become a Brand Partner</Link>
                        <Link to="/contact" className="btn-outline" data-testid="brand-contact">Talk to Us</Link>
                    </div>
                </div>
            </section>
        </PageLayout>
    );
}
